// eslint-disable-next-line no-undef
customEventPush = (function() {
  /**
   *
   */
  const self = {};

  /**
   *
   * @param eventName
   * @returns
   */
  self.customEventPush = function(eventName) {
    const EVENT_TORIGGER_NAME = 'custom_event_handle';
    const EVENT_DATALAYER_NAME = 'custom_event_handle';
    if (window.dataLayer) {
      window.dataLayer.push({
        event: EVENT_TORIGGER_NAME,
        [EVENT_DATALAYER_NAME]: eventName,
      });
    }
  };

  return self;
})();
